export default "__VITE_ASSET__D$vcgoUN__"